export default "__VITE_ASSET__Desl6Bk6__"